module.exports = {
  // 共通
  common: {
    query: "Query",
    search: "Search",
    add: "Add",
    new: "New",
    update: "Update",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    submit: "Submit",
    cancel: "Cancel",
    back: "Back",
    save: "Save",
    loading: "Loading...",
    operation: "Operation",
    error: "Error",
    warning: "Warning",
    export: "Export",
    tips: "Tips",
    deletedSuccessfully: "Deleted successfully",
    deletionCancelled: "Deletion cancelled",
    confirmClosing: "Confirm closing?",
    contentIsUnchanged: "Content is unchanged",
    anErrorOccurred: "An error occurred",
    required: "Required",
    noPermission: "No permission",
    pleaseSelect: "Please select",
    selectDuration: "Select duration",
    reset: "Reset",
    details: "Details",
    showSearch: "Show Search",
    hiddenSearch: "hidden search",
    show: "show",
    hidden: "hidden",
    showCol: "Explicit Column",
    user: "User",
    colon: ":",
    yes: "YES",
    not: "NO",
    optional: "Optional"
  },

  // 登录画面
  loginPage: {
    language: "Language",
    title: "Background Management System",
    usernamePlaceholder: "Please enter username",
    passwordPlaceholder: "Please enter password",
    verifyCodePlaceholder: "Please enter verification code",
    changeVerityCode: "Change",
    loginBtn: "Login",
    registerLink: "Register",
    forgetPasswordLink: "Forget password",

    // rules:error check
    userNameCheck: "Username must be filled",
    passwordCheck: "Password must be filled",
    verifyCodeCheck: "Verification code must be filled",
    welcomeMessage: "Welcome!  ",
    loginFailed: "Failed to login!",
    verificationFailed: "Verification failed!",
    connectionError: "Connection Error！"
  },

  // 退出登录
  signOutPage: {
    signOut: "Sign Out",
    confirmMsg: "Are you sure you want to sign out?"
  },

  // sample画面
  samplePage: {
    inputPlaceholder: "Please input something...",
    registerDate: "registerDate",
    name: "name",
    address: "address",
    sex: "sex",
    male: "male",
    female: "female",
    age: "age",
    operation: "operation"
  },
  mainPage: {
    useMonitor: "使用监控",
    customerManagement: "客户管理",
    greenJacketForum: "绿夹克讲坛",
    marketingPromotion: "营销推广"
  },
  //修改密码
  changePassword: {
    oldPassword: "Old password",
    newPassword: "New password",
    previousStep: "Previous",
    confirm: "Confirm",
    pleaseRegisterFirst: "Please register first",
    userDoesNotExist: "User does not exist",
    oldPasswordError: "Old password error!",

    confirmPassword: "Confirm Password",
    pleaseEnterPassword: "password can not be blank",
    pleaseEnterThePasswordAgain: "Please enter the password again",
    numbers: "8-16 digits, there must be letters and numbers!",
    passwordNotMatch: "The passwords entered twice do not match!",
    anErrorOccurred: "An error occurred",
    newUsersPleaseChangePasswordsFirst:
      "New users please change passwords first!",
    passwordChangedSuccessfully: "Password changed successfully！",
    atLeast6: "Password length: at least 6 digits"
  },
  // 上传附件
  uploadAttachment: {
    maxUploadNumCheck: "最大上传文件个数：",
    // uploadTypeCheck: "上传的文件只能是.jpg .jpeg .png .gif .pdf格式！",
    sameFileNameCheck: "不支持上传同名文件！",
    fileSizeCheck: "上传的文件大小不能超过50MB！"
    // sameFileNameCheck: "Uploading files with the same name is not supported!",
  },
  // 课程设置
  courseOption: {
    createTheCourses: "Create the courses",
    field: "Field",
    category: "Category",
    courseNumber: "Course number",
    courseName: "Course name",
    targetStudents: "Target students",
    qualificationRequirements: "Qualification requirements",
    form: "Form",
    classLanguage: "Class language",
    duration: "Duration",
    days: "day",
    hours: "hour",
    minutes: "minute",
    numberLimit: "Number limit",
    certificate: "Certificate",
    coursewareLink: "Courseware link",
    introduction: "Introduction",
    pleaseSelectField: "Please select field",
    pleaseEnterCourseName: "Please enter course name",
    pleaseSelectForm: "Please select form",
    pleaseEnterDuration: "Please enter duration",
    pleaseSelectCategory: "Please select category",
    pleaseEnterCourseNumber: "Please enter course number",
    pleaseEnterNumberLimit: "Please enter number limit",
    pleaseEnterPositiveInteger: "Please enter positive integer",
    pleaseEnterNumber: "Please enter number/letter",
    courseInquiry: "Course inquiry",
    number: "Number",
    courseDetails: "Course details",
    normalCourses: "Paid courses",
    freeCourses: "Free courses",
    classAddress: "Address",
    courseLinkPhone: "Browse course selection link on mobile phone",
    createQrCode: "Download QR code",
    browseCourseQRPhone:
      "Browse the QR code of course selection on mobile phone",
    courseType: "Course type",
    courseQRCode: "Course QR code",
    publicCourse: "Public course",
    internalCourse: "Internal course",
    videoUrl: "Video link",
    videoPassword: "Video password",
    pleaseSelectCourseType: "Please select course type",
    pleaseEnterVideoUrl: "Please enter video link"
  },
  // 排课与定价
  schedulingAndPricing: {
    meetingId: "Meeting ID",
    schedulingAndPricing: "Scheduling and pricing",
    recentSchedule: "Recent schedule",
    enter: "Enter",
    unitPrice: "Unit price",
    classLink: "Class link",
    teachers: "Teachers",
    dateAndTime: "Date and time",
    endDateAndTime: "End Date and time",
    linkPassword: "Meeting password",
    pleaseDoNotEnterCommas: "Please do not enter commas",
    duplicateMailboxExists: "Duplicate teacher exists, please replace",
    pleaseSelectDateAndTime: "Please select date and time",
    pleaseSelectEndDateAndTime: "Please select end date and time",
    pleaseEnterUnitPrice: "Please enter unit price",
    priceFormatIsIncorrect: "Please enter correct price",
    pleaseSelectCurrency: "Please select currency",
    pleaseEnterClassLink: "Please enter class link",
    linkFormatIsIncorrect: "Link format is incorrect",
    pleaseEnterLinkPassword: "Please enter link password",
    signUpLink: "Sign up link",
    pleaseEnterTheRegistrationLink: "Please enter the registration link",
    autoMade: "Auto Create",
    videoPassword: "Video password",
    videoLink: "Video link",
    pleaseInClassAddress: "Please enter the class address",
    msg1:
      "The interval between the end date and the time is less than the duration"
  },
  // p0211
  p0211: {
    addIndividualUser: "Adding an Individual User",
    templateImport: "Template to import",
    upload: "Upload",
    lastName: "Last name",
    firstName: "First name",
    nickName: "Nickname",
    email: "Email",
    inCompany: "Working company/organization",
    position: "Position",
    englishLastName: "English last name",
    englishFirstName: "English first name",
    sex: "Gender",
    sexSelection: "Please select gender",
    male: "Male",
    female: "female",
    telephone: "Mobile phone",
    phoneArea: "Area code",
    department: "Department",
    remarks: "Note",
    submit: "Submit",
    handlEmpty: "Empty",
    downloadTemplate: "Download the template",
    uploadTemplate: "Upload the template",
    checkLastName: "Please enter your last name",
    checkFirstName: "Please enter your first name",
    checkEnglishLastName: "Please enter your English last name",
    checkEnglishOnly: "English only",
    checkEnglishFirstName: "Please enter your English first name",
    checkPhone: "Please enter the phone number",
    telephoneFormat: "The telephone format is incorrect!",
    checkEmail: "Please enter email address",
    correctEmail: "Please enter the correct email address",
    replaceEmail: "Duplicate mailboxes exist. Replace them",
    replacePhone: "Duplicate phone numbers exist. Please replace them",
    errorOccurred: " Error occurred",
    imageFormat: "Upload profile picture can only be JPG format!",
    imageSize: "The size of the uploaded profile picture cannot exceed 2MB!",
    length: "length",
    maxEmail: "Enter a maximum of three email addresses",
    maxPhone: "Enter a maximum of three phone numbers",
    individualuser: "Individual user information submitted successfully!",
    existTemplate:
      "Template file does not exist, please contact administrator!",
    fileName: "6-digitCourseNumber_YYYY-MM-DD_HH-MM.xls",
    errorTemplate: "Template download failed, please contact administrator!",
    successTemplate: "Template uploaded successfully!",
    templateTypeErr: "The uploaded template can only be in XLS or XLSX format!",
    errorMessage: "The error message",
    importFailure:
      "Failed to import registration information, please contact the administrator！",
    importSuccess: "Registration information imported successfully!",
    mustInput: "Email and cell phone number, must have an input!",
    msg1: "Name Changed",
    msg2: "Name  Mismatch",
    msg3: "Chinese/English Only"
  },
  //p0213
  p0213: {
    basicInformation: "Basic information",
    careerInformation: "Professional information",
    birthday: "Birthday",
    loginEmail: "Login email",
    birthCountryRegion: "Country/region of birth",
    nationality: "Nationality",
    documentType: "Id name",
    MartialStatus: "Marriage",
    childrenCnt: "Children",
    motherTongue: "Mother tongue",
    hobby: "Hobby",
    birthProvince: "Province of birth",
    birthCity: "City",
    documentNo: "ID number",
    otherLanguages: "Other languages",
    nowAddress: "Now address",
    nation: "Nation",
    loginPhone: "Login phone",
    correctDocumentNo:
      "The ID number can only be entered in English and digits!",
    replaceDocumentNo:
      "The input document information is duplicate, please confirm!",
    userInformationFailed:
      "Personal user information query failed, please contact the administrator!",
    saveInformationFailed:
      "Failed to save basic information, please contact the administrator!",
    saveInformationSuccess: "Basic information saved successfully!",
    qualification: "Qualification",
    professionalSkills: "Professional skills",
    degree: "Degree",
    graduationYear: "Graduation year",
    schoolOfGraduation: "school of graduation",
    AffiliatedCompany: "Affiliates/Institutions",
    servedInOffice: "Served in office",
    personalResume: "Personal Resume",
    qualificationAttachments: "Qualification attachments",
    remarks: "Note",
    contentIsUnchanged: "Content is unchanged",
    industryExperience: "Industry Experience",
    functions: "Functions",
    technicalExp: "Product/Technical Experience",
    projectExp: "Project Experience",
    emailPhoneNotDelet:
      "The email address and mobile phone number cannot be deleted!",
    savedSuccessfullyPS: "Professional skills information saved successfully!",
    saveFailedPS:
      "Professional skills information failed to save, please contact the administrator!",
    savedSuccessfullyQS: "Qualification information saved successfully!",
    saveFailedQS:
      "Failed to save qualification information. Please contact the administrator!",
    pleaseEnter: "Please enter",
    reportsQuery: "Reports Query",
    feeSettlement: "Fee Settlement",
    classDateAndTime: "Class date and time",
    courseNumber: "Course number",
    courseName: "Course name",
    introductoryNumber: "Introductory number",
    singleCommission: "Single commission",
    totalCommission: "Total commission",
    currency: "Currency",
    settlementStatus: "Settlement status",
    paymentTime: "Pay time",
    proofOfPayment: "Proof of payment",
    view: "View",
    topTotalCommission: "Total Cumulative Commission",
    unsettledAmount: "Unsettled Amount",
    CNY: "CNY",
    pointsCou: "Points Statistics",
    oprLog: "Operation Log",
    oprModule: "Operation",
    oprContent: "Operation Content",
    oprTime: "Operation Time",
    salesUser: "Salesperson",
    setSalesUser: "Set up as a salesperson",
    tqsOpr: "TQS Operation",
    lastLogin: "Last Login",
    tqsPoints: "TQS Points",
    checkPoints: "Please complete the TQS Points Zone",
    checkLog: "There is no operational log to export",
    selectExportDate: "Select the date range for export",
    startDate: "Start date",
    endDate: "End date",
    setAsTrainer: "Set as Trainer",
    tag: "Label",
    region: "Region",
    subarea: "Subarea",
    affiliation: "Affiliation",
    affiliationEnterMsg: "Please select affiliation",
    isInternalTrainingAuthorized: "Is Internal Training Authorized Employee"
  },
  p0321: {
    requiredOptions: "Required Options",
    title: "Title",
    phone: "Phone",
    company: "Company/Organization",
    position: "Position",
    birthday: "Birthday",
    scheduleStatus: '排课状态',
    normal: "正常",
    postponement: "延期",
    registered: "已报名",
    status: '状态',
    msg1:"此操作将延期该课程, 是否继续?",
    msg2:"延期成功",
    courseStatus:"课程状态"
  },
  //p0322
  p0322: {
    classInvitation: "class invitation",
    numbering: "Numbering",
    courseTitle: "Course Title",
    classDates: "Class Dates",
    addStudents: "Add students",
    name: "Name",
    audition: "Audition",
    auditionTip: "Check the trial students, effective immediately",
    save: "Save",
    saveAudition: "Save successfully",
    mail: "Login mail",
    cellPhone: "Login cell phone",
    company: "Company",
    position: "Position",
    state: "State",
    invited: "Invited",
    invitedFaild: "Invitation Failed",
    notInvited: "Not invited",
    sendAnInvitation: "Send an invitation",
    return: "Return",
    noStudentSelected: "No student selected",
    invitationSucceeded: "Invitation succeeded",
    emailCanNotBeEmpty: "E-mail can not be empty",
    invite: "Invite",
    qrCode: "Registration QR code",
    editClassSchedule: "Edit class schedule",
    deleteEditClassSchedule: "Are you sure to delete the schedule information?",
    text1:
      "The class schedule is not filled in with the class link! Please fill in the class link first and try to invite again!",
    text2:
      "The class schedule is not filled in with the meetingId! Please fill in the meetingId first and try to invite again!",
    text3:
      "The class schedule is not filled in with the video link! Please fill in the video link first and try to invite again!",
    applicantNumber: "Number of applicants",
    person: "person",
    unlimited: "Unlimited",
    cumulativeNumberApplicants: "Cumulative number of applicants",
    numberPeopleLearning: "Number of people in learning"
  },
  //p0323
  p0323: {
    personalUser: "personal user",
    avatar: "avatar",
    name: "Name",
    englishName: "English name",
    nickName: "Nick name",
    mail: "TQS login mail",
    cellphoneNumber: "TQS login cellphone number",
    submit: "submit",
    noStudentSelected: "No student selected",
    addedSuccessfully: "Added successfully",
    text1: "Name,English name,Mail,cellphone number"
  },
  p0324: {
    postponementCancellation: "解除延期",
    msg1: "Trainer",
    msg2: "Lose your certification and don't show it anymore!",
    msg3:"请设置大于等于当前天的时间。",
    msg4:"此操作将该课程的延期解除, 是否继续?"
  },
  //p0331
  p0331: {
    classRecord: "class record",
    category: "category",
    numbering: "Numbering",
    courseTitle: "Course Title",
    classTime: "class time",
    numberOfApplicants: "Number of applicants",
    numberOfStudentsInClass: "Number of students in class",
    unitPrice: "unit price",
    totalCharge: "total charge",
    currency: "currency",
    passingRate: "Passing rate",
    operate: "operate",
    details: "Details",
    teacher: "teacher"
  },
  // 个人用户一览查询画面
  p0212: {
    personalUser: "personal user",
    headPortrait: "head portrait",
    userName: "user name",
    englishName: "english name",
    nickname: "nickname",
    registerDate: "TQS register date",
    introducer: "introducer",
    lastUpdateDate: "last update date",
    operate: "operate",
    details: "details",
    searchPlaceholder: "user name, english name, nickname, email, phone",
    noFindCompanyInfo: "No company/organization information was found!",
    couponCode: "Coupon code",
    couponCodeLevel: "Coupon code level",
    export: "Export the coupon code",
    couponFileName: "couponCodesAtGlance",
    couponFileFormat: ".xls",
    errorCoupon: "File download failed, please contact the administrator!",
    existCoupon: "Coupon code does not exist",
    existingCompany: "Affiliates"
  },
  //p0332
  p0332: {
    classRecordDetails: "Class record details",
    gradeTemplateImport: "Grade Template Import",
    downloadTemplate: "Download template",
    uploadTemplate: "Upload template",
    pinyinSurname: "pinyin_surname",
    pinyinName: "pinyin_name",
    mail: "Login mail",
    cellPhone: "Login cell phone",
    company: "Company",
    position: "Position",
    yes: "Yes",
    no: "No",
    noClass: "no class",
    testScores: "test scores",
    noPass: "no pass",
    submit: "submit",
    errorMessage: "error message",
    thisCourseIsNot:
      "This course is not bound to a certificate! Please bind the certificate first and try to submit again!",
    submittedSuccessfully: "Submitted successfully",
    importSucceeded:
      "Score information imported successfully and submitted automatically",
    pageRefreshed: "Page refreshed",
    unmodified: "unmodified",
    gradesCannotBeEmpty: "Grades cannot be empty",
    enterNumbersOnly: "Enter numbers only",
    lastNameCannotBeEmpty: "Last name cannot be empty",
    englishOnly: "English only",
    nameCannotBeEmpty: "name cannot be empty",
    setLinkCourseRecord: "Set up a link to the course recording",
    enterLinkRecord: "Please enter the link to the course recording",
    enterLinkTitle: "Please enter a course title",
    linkFormatIsIncorrect: "Link format is incorrect",
    linkRecordSetSuccess: "The course recording link is set successfully!",
    courseVideoLink: "Course video link",
    downloadTheVideoQrCode: "Download the video QR code",
    btn1: "下载视频回放二维码",
    btn2: "下载视频回放推广二维码",
    msg1: "未设置视频回放链接",
    noLessons: "No lessons",
    classesHaveBeenTaken: "Classes have been taken",
    bt3:"二维码下载",
    bt4:"复制链接",
    msg2:"复制成功",
    setLinkCourseRecord2: "视频回放推广",
    isInternalTrainingAuthorized: "内训授权",
  },
  // 证书管理
  certificateManagement: {
    newCertificate: "New certificate",
    definitionName: "Definition name",
    definitiontemplate: "Definition template",
    relatedCourses: "Related courses",
    issuanceMethod: "Issuance method",
    aCourse: "A course",
    multipleCourses: "Multiple courses",
    clickAndDbClick: "Click Select and double-click Preview",
    pleaseEnterDefinitionName: "Please enter definition name",
    pleaseSelectDefinitionTemplate: "Please select definition template",
    pleaseSelectRelatedCourses: "Please select related courses",
    pleaseSelectIssuanceMethod: "Please select issuance method",
    duplicateRelatedCourseExists: "Duplicate related course exists",
    courseCertificateDescription: "Course certificate description",
    pleaseEnterDescription: "Please enter course certificate description",
    msg1: "Please enter a course name"
  },
  // 查看证书
  viewCertificate: {
    checkCertificate: "Edit Certificate Settings",
    deleteInformation:
      "Are you sure you want to delete certificate information?",
    queryingCertificate: "Query the certificate",
    name: "Name",
    template: "Template",
    associateCourse: "Related courses",
    authenticationMethod: "Authentication method",
    lastEdited: "Last edited",
    display: "Display"
  },
  p0101: {
    userStatistics: "Individual user registration statistics",
    registrationNumbers: "TQSCloud individual user registration number: ",
    month: "Month",
    curMonthUserNums:
      "Number of new registered individual users in the current month",
    curMonthAdminNums: "Number of newly registered managers in the month",
    cumMonthNumbers: "Cumulative number of individual user registrations"
  },

  p0102: {
    companyStatistics: "Company/Institution Registration Statistics",
    registrationNumbers:
      "Number of TQSCloud registered companies/institutions: ",
    month: "Month",
    curMonthNumbers:
      "Number of registered companies/institutions in the current month",
    cumMonthNumbers: "Cumulative number of registered companies/institutions"
  },
  // 公司机构查询一览
  p0202: {
    companyOrganizationName: "Company/Organization Name",
    companyRegisteredName: "Registered name",
    companyShortName: "abbreviation",
    englishName: "English name",
    managers: "managers",
    numberOfPeople: "crew size"
  },
  p0204: {
    companyAddress: "公司地址",
    selectProvince: "选择省直辖市",
    selectCity: "选择市区",
    china: "China",
    registeredName: "Registered Name",
    shortName: "Short Name",
    registration: "Registration",
    province: "Province",
    city: "City",
    area: "Area",
    registeredAddress: "Registered Address",
    contactNumber: "Contact Number",
    contactAddress: "Contact Address",
    industry: "Industry",
    companyTaxNumber: "Company Tax Number",
    countryOfRegistration: "Country Of Registration",
    englishName: "English Name",
    companyRepresentativeContact: "Company Representative/Contact",
    companyWebsite: "Company Website",
    remark: "Remark",
    companyInformation: "Company Information",
    edit: "Edit",
    save: "Save",
    canNotBeEmpty: "Can Not Be Empty",
    pleaseEnterYourPhone: "Please Enter Your Phone",
    wrongPhoneFormat: "Wrong Phone Format",
    successfullySaved: "Successfully Saved"
  },
  p0203: {
    basicInformation: "Basic Information",
    personnelInformation: "Personnel information"
  },
  p0205: {
    deleteThisUser: "Delete this user?",
    deleteThisCompany: "Delete the company?"
  },
  newYouHuiMa: {
    certificate: "证书",
    TQSTemplateUsage: "TQS模板使用",
    greenJacketClassName: "绿夹克上课名称",
    greenJacketClassDate: "绿夹克上课日期",
    individualUser: "个人用户",
    queryCriteria: "姓名/英文姓名/手机/Email/资质",
    promoCodeLevel: "优惠码级别",
    avatar: "头像",
    name: "姓名",
    englishName: "英文姓名",
    email: "邮箱",
    phoneNumber: "手机号码",
    affiliation: "所属机构",
    registerDate: "注册日期",
    lastLogin: "上次登录",
    createAndNotify: "创建并通知",
    qrCodeTitle: "扫码获取优惠码",
    createQrCode: "下载二维码"
  },
  p0412: {
    defaultOffer: "Default Offer",
    courseNumber: "Course Number",
    courseName: "Course Name",
    studentDiscount: "Student Discounts",
    introducerCommission: "Introducer Commission",
    deductionAmount: "The deduction amount based on the standard price",
    deductionRatio: "Percentage deduction based on standard price",
    quoteCurrency: "（Kurt Kulensi）",
    fixedAmount: "Fixed amount",
    ratio: "Scales based on standard prices",
    twoDecimals: "Please enter a number",
    integer: "Please enter an integer between 0 and 99",
    enterNumber: "Please select a course number",
    enterName: "Please select a course name",
    OfferSetSuccess: "Offer Settings submitted successfully!"
  },
  p0413: {
    specialOffer: "Special Offer Settings",
    limitedTime: "Limited Time Special Offer",
    specifyPerson: "Special Offers for Designated Persons",
    courseNumber: "Course Number",
    courseName: "Course Name",
    queryCriteria: "Phone/Email/Coupon code",
    classDate: "Class date and time",
    studentDiscount: "Student discounts",
    introducerCommission: "Introducer commission",
    couponCode: "Coupon code",
    individualUser: "Individual users",
    name: "Name: ",
    email: "Email: ",
    phone: "Phone Number: ",
    codeCoupon: "Coupon Code: ",
    selectCourse: "Please select course number and course name",
    enterQuery: "Please enter your phone, email , and coupon code to inquire",
    specialSetSuccess: "Nominated person discount submitted successfully!",
    LimitSetSuccess: "The limited-time offer was submitted successfully！",
    offerSettings: "Offer Settings"
  },
  p0401: {
    intro: "Referrer",
    sales: "Salesperson",
    lastUpdated: "Last Updated",
    tqsPoints: "TQS Points",
    position: "Position",
    promoCodeLevel: "Promo Code Level",
    promoCode: "Promo Code",
    emailGroupQueryMemberListEmail: "Email group query member list",
    tqsOperation: "TQS operation"
  },
  // 群公告、Email群查询P0403、P0404
  emailGroup: {
    groupAnnouncement: "Group Announcement",
    queryEmailGroup: "Query Email Group",
    emailGroupName: "Email Group Name",
    fuzzySearch: "Fuzzy Search",
    groupDescription: "Group Description",
    peopleCount: "People Count",
    createDate: "Create Date",
    lastAnnouncement: "Last Announcement",
    state: "State",
    operation: "Operation",
    historical: "Historical",
    void: "Void",
    effective: "Effective",
    recover: "Recover",
    newAnnouncement: "New Announcement",
    nickName: "Nickname",
    graduate: "Start year is less than end year",
    createEmailGroup: "New Email Group",
    newEmailGroupName: "Add Email Group Name",
    newEmailGroupDesc: "Email Group Summary/Description",
    curCompany: "Current Company",
    education: "Academic qualifications",
    beforeCompany: "Worked for",
    graduateYear: "Year of graduation",
    couponCodeLevel: "Coupon Code Level",
    userSearchValue: "Keyword",
    inputGroupName: "Please enter the email group name",
    inputGroupDesc: "Please enter Email group profile",
    maxLength255: "Maximum length 255 characters",
    maxLength500: "Maximum length 500 characters",
    to: "to",
    addMembers: "Please select group members",
    email: "Email",
    qtr: "Qualification/position/residence",
    pleaseSelect: "Please select a member"
  },
  p0403: {
    newAnnouncement: "New Announcement",
    announcementTemplate: "Add announcement template",
    select: "Select",
    courseName: "Class Name",
    dateAndTime: "Date & Time",
    time: "Time",
    company: "Company",
    address: "Location",
    reportLink: "Learning report link",
    content1: "Your coupon code is",
    content2: "The registration can be directly deducted for this registration",
    content3: "￥.",
    body: "Full text",
    attachment: "Add Attachment",
    selectAttachment: "Select file",
    send: "Send",
    selectAnnouncementTemplate: "Select announcement template",
    selectTemplate: "Select template",
    selectCourseName: "Select class name",
    selectDateAndTime: "Select date and time",
    selectCompany: "Select Company",
    selectAddress: "Select a location",
    pleaseSelectCourseName: "Please select a class name",
    pleaseSelectDateAndTime: "Please select date and time",
    pleaseSelectCompany: "Please select the company",
    pleaseSelectAddress: "Please select a location",
    sendSuccess:
      "The sending task is created successfully and the system is sending automatically",
    pleaseEnterContent: "Please enter content",
    pleaseEnterEmailTitle: "Please enter a subject",
    allStaffAnnouncement: "All-staff announcement",
    checkContent: "You have reached your input limit, please delete!",
    emailTitle: "Topics",
    imgCheck:
      "Only images with a size of 15M or less are allowed to be uploaded",
    maxLength200: "主题长度最大为200字符!",
    preview: "preview",
    addLink: "addLink",
    updateLink: "updateLink",
    courseLink: "courseLink",
    studyReportLink: "学习报告链接",
    courseCode: "课程二维码",
    courseEnrollCode: "课程报名二维码",
    videoCode: "视频回放二维码",
    videoCodePromote: "视频回放推广二维码",
    courseCodeCourseNumber: "课程二维码课名",
    courseEnrollCodeCourseNumber: "课程报名二维码课名",
    courseEnrollCodeDateAndTime: "课程报名二维码日期与时间",
    videoCodeCourseNumber: "视频回放二维码课名",
    videoCodeDateAndTime: "视频回放二维码日期与时间",
    studyReportCourseNumber: "学习报告链接课名",
    studyReportDateAndTime: "学习报告链接日期与时间",
    videoCodePromoteCourseNumber: "视频回放推广课名",
    videoCodePromoteDateAndTime: "视频回放推广日期与时间",
    couLink: "课程",
    phoLink: "图片",
    freeLink: "自由链接",
    enterLink: "请输入链接",
    enterImg: "请上传图片"
  },
  p0214: {
    examScores: "Exam scores"
  },
  // 发票信息查询
  p0351: {
    invoiceInquiry: "Invoice information inquiry",
    notIssued: "Not issued",
    issued: "Issued",
    toIssued: "Go and issue it"
  },
  p0352: {
    recipientinfo: "Name/Phone/Invoicing Company",
    selectDate: "Select a date",
    batchIssuance: "Batch issuance",
    exportOfInvoiceInfo: "Export of invoice information",
    viewInvoiceInfo: "View invoice information",
    recipientName: "Recipient name",
    contactNumber: "Contact number",
    registrationTime: "Registration time",
    invoiceType: "Invoice type",
    courseName: "Course name",
    classTime: "Class time",
    noInvoiceInfoExport: "No invoice information",
    noInvoiceInfoExportTitle: "List of invoice information (not issued)_",
    invoiceInfoExportTitle: "Invoice information at a glance (issued)_",
    invoiceInfoExportFail: "Invoice information export failed",
    exportFileFormat: ".xls",
    batchIssuanceSuccess: "Issued successfully",
    invoiceTypeDialog: "Invoice type:",
    invoiceInfo: "Invoice information",
    invoiceTitle: "Invoice title:",
    serviceItems: "Service items:",
    TaxpayeridentifyNo: "Taxpayer identification number:",
    companyRegistAdd: "Company registered address:",
    CorporateFinancialTel: "Corporate financial telephone:",
    bankOfDeposit: "Bank of deposit:",
    bankAccountNo: "Bank account number:",
    wayOfReceive: "Way of receiving:",
    recipientnName: "Recipient's name:",
    contactNo: "Contact number:",
    postalAdd: "Postal address:",
    email: "Email:",
    timeOfIssue: "Time of issue",
    keywords: "Keywords",
    totalAmount: "Total amount credited:",
    remarks: "Remarks:"
  },
  // 公告模板设置P0402
  P0402: {
    announcementTemplateSetting: "Announcement Template Setting",
    newTemplate: "New Template",
    templateName: "Template Name",
    lastUpdate: "Last Update",
    newGroupTemplate: "New Group Template",
    create: "Create",
    title: "Title",
    content: "Content",
    editGroupTemplate: "Edit group template",
    saveAsNewTemplate: "Save as new template",
    variable: "Variable",
    remark: "Note: To add a variable, click the Variables button."
  },
  P0361: {
    orderInquiryTitle: "Order Information Inquiry",
    courseName: "Course Name",
    paymentTime: "Order Pay Time",
    date: "Choose Date",
    keywords: "searchCriteria",
    coursePrice: "Unit Price",
    applicants: "Applicants Number",
    couponCode: "Coupon Code",
    discountedPrice: "Coupon Price",
    totalCredit: "Entry Price",
    purchaser: "Buyer Name",
    purchaserPhone: "Buyer Phone",
    telephone: "Phone",
    invoicingCompany: "Invoicing Company",
    remark: "Remark",
    null: "Null",
    details: "Detail",
    paymentMethod: "Payment Methods",
    orderId: "Order Number"
  },
  p0341: {
    certificatePreview: "Certificate preview",
    previewIsNotSupported: "Preview is not supported",
    thirdPartyCertificateUpload: "第三方证书上传",
    allowed: "允许",
    notAllowed: "不允许",
    selectThirdPartyUpload: "请选择是否第三方上传",
  },
  p0416: {
    statisticalCommissions: "Statistical commissions",
    dateTime: "Class date and time",
    courseNumber: "Course number",
    courseName: "Course name",
    totalCommission: "Total commission",
    amountPaid: "Amount paid",
    currency: "Currency",
    paymentTime: "Payment time",
    details: "Details",
    noSettled: "Not settled",
    settled: "Settled",
    introducer: "References",
    phone: "Mobile phone number",
    company: "Affiliates",
    couponCode: "Coupon code",
    introduceNum: "Introduce the number of people",
    singleCommission: "Single commission",
    pay: "Pay",
    bulkPayments: "Bulk payments",
    selectPaymentTime: "Select the payment time",
    uploadPayProof: "Upload your payment voucher",
    pleaseSelectDateTime: "Please select a payment time",
    export: "Export",
    optionFaild: "The operation failed",
    pleaseSelectUser: "Please select the person who paid in bulk",
    ExportFail: "Export failed",
    noFindCommissionInfo: "There is no billing details yet"
  },
  pointsRule: {
    title: "TQS Points rule setting",
    company: "Points for registering a company account",
    companyPoint:
      "For each successful registration of a company account, the user accumulates",
    TQSPoints: "TQS points",
    countryTitle: "Specify country-specific settings：",
    register: "register",
    selectCountry: "Please select a country",
    countryPoints: "Company accounts, ",
    user: "user accumulates",
    points8D: "Points for using 8DReport",
    D8Points: "Complete an 8D report, D8 team leader accumulates",
    D1Points:
      "In the 8D report, for each successful invitation to a group member or contact to register, the inviter accumulates",
    share8DPoints:
      "By sharing 8D reports, for each successful registration of a recipient, people who share accumulates",
    qualityToolPoints: "Points for using quality tool",
    fishPoints: "Complete a fishbone report analysis, user accumulates",
    points5W2H: "Complete a 5W2H report analysis, user accumulates",
    points5WHY: "Complete a 5Why report analysis, user accumulates",
    pointsIN: "Complete a Is / IsNot report analysis, user accumulates",
    shareTools:
      "By sharing the quality tool reports, for each successfully registered, people who share accumulates",
    greenJacketPoints: "Points for using greenJacketForum",
    GJFPoints: "For each completion of the GJF course, accumulate",
    coefficient: "+ (Fees paid  x",
    coefficientTQSPoints: "%  )   TQS points",
    ps:
      "(Remark: Payment is calculated in CNY, If you pay USD, it will be converted to CNY, The calculation method is rounded)",
    pointCoupon:
      "The beneficiary uses the coupon code for each GJF course completed, and the coupon code owner accumulates",
    submit: "Submit",
    noChange: "The content has not changed",
    submitSuccessfully: "The submission information was successful",
    submitfailed: "Failed to submit information",
    almostPointsRule:
      "Please enter a positive integer with a maximum of three digits",
    coefficientRule:
      "Only integers or decimal places from 0 to 100 can be entered"
  },
  p0216: {
    currentPoints: "CurrentPoints：",
    points: " points",
    usedPoints: "Accumulated used：",
    pleaseSelect: "please Select",
    selectTime: "Time",
    select: "Select",
    apply: "application",
    operation: "Operation",
    selectPoints: "Points"
  },
  p0433: {
    personalUser: "个人用户",
    headPortrait: "头像",
    userName: "姓名",
    englishName: "英文姓名",
    nickname: "昵称",
    introducer: "介绍人",
    lastUpdateDate: "上次更新",
    operate: "操作",
    details: "详细",
    searchPlaceholder: "姓名、英文姓名、昵称、邮箱、手机号",
    searchPlaceholder1: "课程名称，编号",
    noFindCompanyInfo: "未查询到公司/机构信息！",
    couponCode: "优惠码",
    couponCodeLevel: "优惠码级别",
    export: "导出优惠码",
    couponFileName: "优惠码一览",
    couponFileFormat: ".xls",
    errorCoupon: "文件下载失败，请联系管理员！",
    existCoupon: "优惠码用户不存在",
    existingCompany: "关联公司",
    position: "职位",
    courseNumber: "课程编号",
    courseName: "课程名称",
    currency: "货币",
    classTime: "上课时间",
    uploadPayProof: "上传支付凭证",
    enterLink: "请输入链接",
    selectTime: "时间",
    state: "状态",
    proofOfPayment: "支付凭证",
    selectPaymentTime: "选择支付时间",
    paymentTime: "支付时间",
    qualificationStatus: "资格状态",
    qualificationSize: "资格数量",
    registeredMobile: "注册手机",
    registeredEmail: "注册邮箱",
    certifiedCourseCount: "认证课程数",
    certificationCourse: "认证课程",
    classDetails: "上课明细",
    cancelTrainerQualification: "取消培训师资格",
    restoreTrainerQualification: "恢复培训师资格",
    addTrainer: "新增培训师",
    normal: "正常",
    cancelled: "取消",
    addCourse: "新增课程",
    uncertain: "不确定",
    withTravelExpense: "含差旅费",
    withoutTravelExpense: "不含差旅费",
    enterTrainingCost: "请输入培训费用",
    cumulativeTrainingCost: "累计培训费用",
    unsettledTrainingCost: "待结算培训费用",
    satisfactionSurvey: "满意度调查",
    payment: "支付",
    paymentDetails: "支付明细",
    paymentVoucher: "支付凭证",
    enterPaymentTime: "请输入支付时间",
    selectUserToAdd: "请选择要添加的用户",
    enterNumber: "请选择课程编号",
    enterName: "请选择课程名称",
    OfferSetSuccess: "优惠设置提交成功！",
    registerDate: "注册日期",
    trainingCost: "培训费用",
    trainerSearch: "培训师查询",
    travelExpense: "差旅费用",
    editCourse: "编辑课程",
    operationSuccess: "操作成功",
    disqualifyTraining: "此操作会取消培训资格",
    view: "查看",
    satisfactionSurveyLink: "满意度调查链接",
    unsettled: "未结算",
    deleteCourseWarning: "此操作会删除认证课程",
    settled: "已结算",
    addedSuccessfully: "添加成功",
  },
  resourceUserQuery:{
    resourceUser: "资源用户",
    personalUser: "个人用户",
    headPortrait: "头像",
    userName: "姓名",
    englishName: "英文姓名",
    nickname: "昵称",
    details: "详细",
    searchPlaceholder: "姓名、英文姓名、手机、邮箱",
    searchKey: "请输入关键字",
    enterSubarea: "请输入分区",
    enterRemarks: "二维码备注说明，仅用于区分二维码",
    tag: "标签",
    region: "区域",
    subarea: "分区",
    email: "邮箱",
    phone: "手机",
    existingCompany: "关联公司",
    resourceUserImport: "资源用户导入",
    setTag: "设置标签",
    setArea: "设置区域",
    qRCodeDownload: "注册二维码下载",
    downloadCodeTitle: "下载二维码",
    download: "下载",
    resetTag: "重置标签",
    registerResourceCode: "注册二维码",
    existTemplate: "模板文件不存在，请联系管理员！",
    fileName: "6位课程编号_YYYY-MM-DD_hh-mm.xls",
    errorTemplate: "模板下载失败，请联系管理员！",
    successTemplate: "模板上传成功！",
    templateTypeErr: "上传模板只能是 xls、xlsx格式!",
    importFailure: "信息导入失败，请联系管理员！",
    resourceUserTemplate: "资源用户导入模板.xls",
    submitSuccess: "提交成功！",
    errorOccurred: "发生错误",
    userQuery: "用户查询",
    errorMessage: "错误信息",
    bindingState: "微信绑定",
    notBound: "未绑定",
    bound: "已绑定",
    remarks: "备注",
    msg1:"已超过最大文字数",
    sendAgain:"再次发送",
    msg9:"发送成功",
    affiliation: "所属机构",
    affiliationEnterMsg: "请选择所属机构"
  }
};



// WEBPACK FOOTER //
// ./src/language/langs/en.js